// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2uNXQ","left":"InfoRow_left__2LMNh"};